import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/theme.css";
import "./Confirmation.css";
import Footer from "../components/Footer";

const formatSek = (amount) =>
  new Intl.NumberFormat("sv-SE", {
    style: "currency",
    currency: "SEK",
  }).format(Number(amount || 0));

const Confirmation = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    selectedPlan,
    selectedAddOns = [],
    totalPrice,
    paymentMethod,      // display string (maybe)
    selectedPayment,    // key: "stripe" | "paypal" | "bank" (maybe)
    userDetails,
    orderId,
  } = location.state || {};

  const paymentLabelMap = {
    stripe: t("pricing.methods.card"),
    paypal: t("pricing.methods.paypal"),
    bank:   t("pricing.methods.bank"),
  };

  const paymentLabel =
    paymentMethod || (selectedPayment ? paymentLabelMap[selectedPayment] : "");

  return (
    <div className="confirmation-container">
      <h1 className="confirmation-title">{t("confirmation.title")}</h1>
      <p>{t("confirmation.thank_you")}</p>

{/* ✅ Order ID */}
{orderId && (
  <div
    style={{
      marginTop: "12px",
      padding: "10px 14px",
      background: "#eef3ff",
      borderLeft: "4px solid #0110FC",
      borderRadius: "6px",
      fontSize: "14px",
      color: "#0a0f2c",
      fontWeight: "500",
    }}
  >
 <strong>{t("confirmation.order_id")}:</strong>{" "}
<span style={{ color: "#0a0f2c" }}>
  {orderId}
</span>
  </div>
)}

      {/* ✅ Order Summary */}
      <div className="order-summary">
        <h2>{t("confirmation.order_summary")}</h2>
        <p>
          <strong>{t("checkout.selected_plan")}:</strong> {selectedPlan}
        </p>

        {selectedAddOns.length > 0 ? (
          <ul>
            {selectedAddOns.map((addon, index) => (
              <li key={index}>
              {addon.name} - {formatSek(addon.price)}
              </li>
            ))}
          </ul>
        ) : (
          <p>{t("confirmation.no_addons")}</p>
        )}

        <h3>
        {t("checkout.total")}: {formatSek(totalPrice)}
        </h3>
        <p>
          <strong>{t("checkout.payment_method")}:</strong> {paymentLabel}
        </p>
      </div>

      {/* ✅ Customer Info */}
      <div className="user-details">
        <h2>{t("confirmation.customer_info")}</h2>
        <p>
          <strong>{t("checkout.name")}:</strong> {userDetails?.name}
        </p>
        <p>
          <strong>{t("checkout.email")}:</strong> {userDetails?.email}
        </p>
        {userDetails?.phone && (
          <p>
            <strong>{t("checkout.phone")}:</strong> {userDetails.phone}
          </p>
        )}
        {userDetails?.address && (
          <p>
            <strong>{t("checkout.address")}:</strong> {userDetails.address}
          </p>
        )}
      </div>

      {/* ✅ Back Button */}
      <button className="back-btn" onClick={() => navigate("/")}>
        {t("confirmation.back_home")}
      </button>

      <Footer />
    </div>
  );
};

export default Confirmation;